import { Skeleton, Stack } from "@mui/material";

import { ErrorTypography } from "components/ErrorTypography";
import { useShipperShipmentPageContext, useTfc } from "hooks";

import { TfcShipperDisplay } from "./components/TfcShipperDisplay";

interface TotalFreightCostSectionProps {
  dividerComponent: JSX.Element;
}

export function TotalFreightCostSection(props: TotalFreightCostSectionProps) {
  const { dividerComponent } = props;
  const { shipment } = useShipperShipmentPageContext();
  const shipmentId = shipment?.info?.id ?? null;
  const { data: tfcData, loading, error, mutate } = useTfc({ shipmentId });

  if (!shipment) return null;
  if (shipment.shipment_status !== "DELIVERED") return null;
  if (shipment.info.type !== "SINGLE") return null;

  // Don't render the section at all if we know TFC doesn't exist
  if (tfcData && !tfcData.exists) return null;

  return (
    <Stack direction="column" mb="1.5rem">
      {dividerComponent}

      {loading && (
        <Stack spacing={1}>
          <Skeleton variant="rounded" width="100%" height={60} />
          <Skeleton variant="rounded" width="100%" height={200} />
          <Skeleton variant="rounded" width="40%" height={36} />
        </Stack>
      )}

      <ErrorTypography error={error} />

      {!loading && tfcData?.exists && shipmentId != null && (
        <TfcShipperDisplay
          tfcData={tfcData}
          shipmentId={shipmentId}
          shipperCompanyName={shipment.shipment_company.name}
          onTfcUpdated={() => {
            mutate();
          }}
        />
      )}
    </Stack>
  );
}
